import { createContext } from 'react'

const magazineContext = createContext( {
  pages: [],
  pageSelected: null,
  itemsWorker: null,
  onAddPage: () => {},
  onRemovePage: () => {},
  onAddElement: () => {}
} )
magazineContext.displayName = 'MagazineContext'

export const MagazineProvider = magazineContext.Provider
export const MagazineConsumer = magazineContext.Consumer


// WEBPACK FOOTER //
// ./src/contexts/magazine.js